"use client"
import { useCurrencies } from "@opensea/app-kit"
import { type BigNumber, bn, UnreachableCaseError } from "@opensea/utils"
import type { CurrencyIdentifier } from "../currencies/utils"
import type { Conversion } from "./types"

type UseUsdPriceValueArgs = {
  currency?: CurrencyIdentifier
  unitPrice?: number
  usdPrice?: number
  conversion?: Conversion
  multiplier?: number
}

export function useUsdPriceValue({
  currency,
  unitPrice,
  usdPrice: usdPriceProp,
  conversion = "current",
  multiplier = 1,
}: UseUsdPriceValueArgs): BigNumber | undefined {
  const { getUsdPrice: getCurrentUsdPrice } = useCurrencies()

  if (!(unitPrice && currency)) {
    return undefined
  }

  const historicalUsdPrice = usdPriceProp ? bn(usdPriceProp) : undefined

  // Compute the base USD price
  const getBaseUsdPrice = () => {
    switch (conversion) {
      case "current":
        return getCurrentUsdPrice(currency, unitPrice) ?? historicalUsdPrice
      case "historical":
        return historicalUsdPrice
      default:
        throw new UnreachableCaseError(conversion)
    }
  }
  const baseUsdPrice = getBaseUsdPrice()

  // Multiply by the given multiplier
  return baseUsdPrice?.times(multiplier)
}
